
import React from "react";
import { PremiumHero } from "./hero/PremiumHero";

const HeroSection = () => {
  return <PremiumHero />;
};

export default HeroSection;
